import React from 'react';
import { lazy } from 'react-loosely-lazy';
import { graphql, useFragment } from 'react-relay';
import Placeholder from '@atlassian/jira-placeholder';
import type { async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection$key } from '@atlassian/jira-relay/src/__generated__/async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection.graphql';
import { SkeletonWrapper, SkeletonItem } from './styled';
import type { VersionRichTextSection } from './index';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyVersionRichTextSection = lazy<typeof VersionRichTextSection>(() =>
	import(/* webpackChunkName: "async-version-rich-text-section" */ './index').then(
		(module) => module.VersionRichTextSection,
	),
);

export const AsyncVersionRichTextSection = ({
	jiraVersion,
}: {
	jiraVersion: async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection$key;
}) => {
	const version = useFragment(
		graphql`
			fragment async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection on JiraVersion {
				...ui_softwareReleasesVersionRichTextSection_VersionRichTextSection
			}
		`,
		jiraVersion,
	);

	return (
		<Placeholder
			name="rich-text-section"
			fallback={
				<SkeletonWrapper>
					<SkeletonItem width="15%" />
					<SkeletonItem width="45%" />
				</SkeletonWrapper>
			}
		>
			<LazyVersionRichTextSection jiraVersion={version} />
		</Placeholder>
	);
};
